import { css } from 'styled-components';
import { SCREENS, SCREENS_PX } from '../responsive';

/** Homepage carousel card widths (Featured, Monthly, etc.) */
export const CAROUSEL_CARD_WIDTH = {
  sm: 220,
  md: 240,
  lg: 250,
} as const;

export const CAROUSEL_CARD_GAP = 16;

/** Card width + gap for arrow scroll (matches CSS breakpoints). */
export function carouselCardScrollAmount(viewportWidth?: number): number {
  const width =
    viewportWidth ?? (typeof window !== 'undefined' ? window.innerWidth : SCREENS_PX.lg);

  if (width >= SCREENS_PX.lg) {
    return CAROUSEL_CARD_WIDTH.lg + CAROUSEL_CARD_GAP;
  }
  if (width >= SCREENS_PX.md) {
    return CAROUSEL_CARD_WIDTH.md + CAROUSEL_CARD_GAP;
  }
  return CAROUSEL_CARD_WIDTH.sm + CAROUSEL_CARD_GAP;
}

export const carouselCardWidthCss = css`
  width: ${CAROUSEL_CARD_WIDTH.sm}px;

  @media (min-width: ${SCREENS.md}) {
    width: ${CAROUSEL_CARD_WIDTH.md}px;
  }

  @media (min-width: ${SCREENS.lg}) {
    width: ${CAROUSEL_CARD_WIDTH.lg}px;
  }
`;
